// Layer 3 (Transformations) for ProjectWorkflowsScene — pure projections over
// workflow seed rows. No React, no engine mutations.

import type { WorkflowRun, WorkflowStatus, WorkflowTrigger } from '@/versions/v1/shared/project-modules-seed';

export function formatTrigger(trigger: WorkflowTrigger): string {
  return trigger === 'manual' ? 'Manual' : 'Schedule';
}

export function statusLabel(status: WorkflowStatus): string {
  if (status === 'running') return 'Running';
  if (status === 'failed') return 'Failed';
  if (status === 'disabled') return 'Disabled';
  return 'Success';
}

export function statusPillTone(
  status: WorkflowStatus,
): 'success' | 'warning' | 'danger' | 'default' {
  if (status === 'success') return 'success';
  if (status === 'running') return 'warning';
  if (status === 'failed') return 'danger';
  return 'default';
}

export function formatLastRun(lastRunAt: number | null, now: number): string {
  if (lastRunAt === null) return 'Never';
  const diff = now - lastRunAt;
  const minutes = Math.floor(diff / 60_000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(lastRunAt).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
  });
}

export function sortWorkflows(rows: WorkflowRun[]): WorkflowRun[] {
  return [...rows].sort((a, b) => {
    const aTime = a.lastRunAt ?? Number.POSITIVE_INFINITY;
    const bTime = b.lastRunAt ?? Number.POSITIVE_INFINITY;
    return bTime - aTime;
  });
}

export function nextWorkflowId(rows: WorkflowRun[]): string {
  const max = rows.reduce((acc, row) => {
    const n = Number.parseInt(row.id.replace(/\D/g, ''), 10);
    return Number.isFinite(n) ? Math.max(acc, n) : acc;
  }, 0);
  return `wf-new-${max + 1}`;
}
